import { Typography } from '@mui/material';
import { PlanShortCardWrapper } from './style';
import SubscriptionPlanType, {
  getSubscriptionPlanLabel,
} from 'crono-fe-common/types/enums/subscriptionPlanType';
import { colors } from 'crono-fe-common/theme';
import IconArrowSTopRight from 'crono-fe-common/icons/Icon-Arrow-S-Top-Right';
import { PlanPrices } from 'crono-fe-common/types/DTO/SubscriptionPlansDTO';
import { cn } from 'utils/style-utils';
import { FeConstants } from 'constants/FeConstants';
import { BillingPlan } from '../../../model';
import { mapBillingPlanToText } from 'utils/businessLogic';

interface IProps {
  type: SubscriptionPlanType;
  price?: PlanPrices;
  billingPlan: BillingPlan;
  onClick?: () => void;
  selected?: boolean;
  className?: string;
  showWhiteBackground?: boolean;
}

const PlanShortCard = ({
  type,
  price,
  billingPlan,
  onClick,
  selected,
  className,
  showWhiteBackground = false,
}: IProps) => {
  const minUsersAmountLabel =
    type === SubscriptionPlanType.PRO
      ? '*Min. 2 users'
      : type === SubscriptionPlanType.ULTRA
        ? '*Min. 3 users'
        : type === SubscriptionPlanType.Custom
          ? '*Ideal for teams with 50+ users'
          : '';
  return (
    <PlanShortCardWrapper
      onClick={onClick}
      className={cn(className ?? '', {
        clickable: !!onClick,
        selected: !!selected,
        'free-trial': type === SubscriptionPlanType.FREE_TRIAL,
        'starter-plan': type === SubscriptionPlanType.STARTER,
        'pro-plan': type === SubscriptionPlanType.PRO,
        'ultra-plan': type === SubscriptionPlanType.ULTRA,
        'custom-plan': type === SubscriptionPlanType.Custom,
        'white-background': showWhiteBackground && !selected,
      })}
    >
      <Typography
        fontSize={'18px'}
        fontWeight={700}
        lineHeight={'24px'}
        color={
          type === SubscriptionPlanType.FREE_TRIAL ||
          type === SubscriptionPlanType.Custom
            ? colors.black
            : undefined
        }
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        {type === SubscriptionPlanType.FREE_TRIAL
          ? `${FeConstants.freeTrialLength} days trial`
          : getSubscriptionPlanLabel(type)}
        {type === SubscriptionPlanType.PRO ? (
          <span className={`badge highlight`}>
            {'Popular'}
            <IconArrowSTopRight color={colors.intenseBlue} />
          </span>
        ) : type === SubscriptionPlanType.ULTRA ? (
          <span className={`badge highlight`}>
            {'Best value'}
            <IconArrowSTopRight color={colors.intenseBlue} />
          </span>
        ) : null}
      </Typography>
      <div className="min-users-amount">{minUsersAmountLabel}</div>
      <div className="plan-pricing">
        {type === SubscriptionPlanType.Custom ? (
          <Typography fontSize={'40px'} fontWeight={600} lineHeight={'40px'}>
            Enterprise
          </Typography>
        ) : (
          <>
            <Typography
              fontSize={'40px'}
              fontWeight={600}
              lineHeight={'40px'}
              color={
                type === SubscriptionPlanType.FREE_TRIAL
                  ? colors.black
                  : undefined
              }
            >
              {type === SubscriptionPlanType.FREE_TRIAL
                ? 'Free'
                : `€${price?.monthlyTotalCycle}`}
            </Typography>
            {type !== SubscriptionPlanType.FREE_TRIAL && (
              <div className="plan-billing">
                <Typography fontWeight={500} lineHeight={'24px'}>
                  User / month
                </Typography>
                <Typography
                  fontWeight={400}
                  lineHeight={'24px'}
                  color={
                    showWhiteBackground && !selected
                      ? colors.grey11
                      : type === SubscriptionPlanType.STARTER
                        ? colors.grey11
                        : colors.white
                  }
                >
                  billed {mapBillingPlanToText(billingPlan)}
                </Typography>
              </div>
            )}
          </>
        )}
      </div>
    </PlanShortCardWrapper>
  );
};

export default PlanShortCard;
